var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 80,
    viewBox: "0 0 146 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7207 2C44.7207 0.895429 45.6161 0 46.7207 0H134.149C135.254 0 136.149 0.895431 136.149 2V70.8571H44.7207V2ZM56.1495 30.7142C56.1495 30.1619 56.5973 29.7142 57.1495 29.7142H82.5781C83.1304 29.7142 83.5781 30.1619 83.5781 30.7142V56.1428C83.5781 56.6951 83.1304 57.1428 82.5781 57.1428H57.1495C56.5973 57.1428 56.1495 56.6951 56.1495 56.1428V30.7142ZM96.0067 29.7142C95.4544 29.7142 95.0067 30.1619 95.0067 30.7142V70.8571H124.721V30.7142C124.721 30.1619 124.273 29.7142 123.721 29.7142H96.0067Z",
    fill: "#00509D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0652 70.1084C34.2515 70.1084 44.1304 60.2295 44.1304 48.0432C44.1304 35.8569 22.0652 16.5215 22.0652 16.5215C22.0652 16.5215 0 35.8569 0 48.0432C0 60.2295 9.87893 70.1084 22.0652 70.1084Z",
    fill: "#56B27E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.9131,
    y: 44.8914,
    width: 6.30435,
    height: 34.6739,
    rx: 1,
    fill: "#00509D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.5776 79.9455C35.5776 74.9262 39.6466 70.8572 44.666 70.8572H136.204C141.223 70.8572 145.292 74.9262 145.292 79.9455C145.292 79.9756 145.268 80 145.237 80H35.6322C35.602 80 35.5776 79.9756 35.5776 79.9455Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6084 7.82617H62.6084V12.6088C62.6084 18.1316 58.1312 22.6088 52.6084 22.6088C47.0856 22.6088 42.6084 18.1316 42.6084 12.6088V7.82617Z",
    fill: "#A2145D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8257 7.82617H87.8257V12.6088C87.8257 18.1316 83.3485 22.6088 77.8257 22.6088C72.3028 22.6088 67.8257 18.1316 67.8257 12.6088V7.82617Z",
    fill: "#A2145D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.043 7.82617H113.043V12.6088C113.043 18.1316 108.566 22.6088 103.043 22.6088C97.5201 22.6088 93.043 18.1316 93.043 12.6088V7.82617Z",
    fill: "#A2145D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.261 7.82617H138.261V12.6088C138.261 18.1316 133.784 22.6088 128.261 22.6088C122.738 22.6088 118.261 18.1316 118.261 12.6088V7.82617Z",
    fill: "#A2145D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3477 2C44.3477 0.895432 45.2431 0 46.3477 0H134.522C135.626 0 136.522 0.895431 136.522 2V7.82609H44.3477V2Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.250c3ce2a7a98aceaa6d49403841a8b5.svg";
export { ForwardRef as ReactComponent };